import Vue from "vue";

import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import isToday from "dayjs/plugin/isToday";

dayjs.extend(utc);
dayjs.extend(isToday);

Vue.prototype.dayjs = dayjs;
